import { BoardTypes } from "../../../../../filters-model";

          /**
   * Este metedo obtiene la cantidad de estrellas,
   * obtenemos solamente la parte que nos interesa del string y la pasamos a un tipo number.
   */
  export function starsHotels(rate): number {

    const rateStar = rate;
    let hotelNumberRate: number = 0;

    if(rateStar != null){
      const numberRate = rateStar?.substring(0,1);
      hotelNumberRate =  Number(numberRate);
    }

    return hotelNumberRate;

  }

  export function getCommentadjective(adjetive: number): string {

          switch(adjetive) {
            case 0: return 'SIN CALIFICAR';
            case 1: return 'Mala';
            case 2: return 'Regular';
            case 3: return 'Buena';
            case 4: return 'Muy buena';
            case 5: return 'Excelente';
          }

  }

export function routeIconsBoardnameHotel(room: any): string {
  const boardName = room?.boardName;

  if (!boardName) {
    return '';
  }

  const normalizedBoardName = boardName.toLowerCase().trim();

  // Buscar en BoardTypes cuál coincide
  const matchedType = BoardTypes.find(type =>
    type.matches.some(match =>
      normalizedBoardName.includes(match.toLowerCase())
    )
  );

  if (!matchedType) {
    return '';
  }

  // Mapear key a ruta de asset
  switch (matchedType.key) {
    case 'breakfast':
      return '../../../../../assets/icons/search-result/hotel/regimen/DESAYUNO.svg';
    case 'half_board':
      return '../../../../../assets/icons/search-result/hotel/regimen/MEDIAPENSION.svg';
    case 'full_board':
      return '../../../../../assets/icons/search-result/hotel/regimen/PENSIONCOMP.svg';
    case 'all_inclusive':
      return '../../../../../assets/icons/search-result/hotel/regimen/ALLINCLUSIVE.svg';
    case 'no_breakfast':
      // Si no tenés icono para sin desayuno, podés retornar un default o ''
      return '';
      // return '../../../../../assets/icons/search-result/hotel/regimen/SIN_DESAYUNO.svg'; // o ''
    default:
      return '';
  }
}

export function boardNameHotel(room: any): string {
  const boardName = room?.boardName;

  if (!boardName) {
    return '';
  }

  const normalizedBoardName = boardName.toLowerCase().trim();

  // Buscar en BoardTypes cuál coincide
  const matchedType = BoardTypes.find(type =>
    type.matches.some(match =>
      normalizedBoardName.includes(match.toLowerCase())
    )
  );

  if (!matchedType) {
    return boardName; // Si no matchea, devolver el nombre original
  }

  return matchedType.label;
}

export function getExtrasFirstRoom(extras: any): any[] {
  if (!extras || !Array.isArray(extras) || extras.length === 0) {
    return [];
  }

  // Mapa de tipos a sus configuraciones
  const typeConfig: Record<string, { image: string; tooltip: string }> = {
    'Transfer': {
      image: '/assets/img/app/categories-search-box/bus.svg',
      tooltip: 'Traslados'
    },
    'Attractions': {
      image: '/assets/icons/search-box/atracciones.svg',
      tooltip: 'Atracciones'
    },
    'Hotel Supplements': {
      image: '/assets/icons/search-result/hotel/icono_sugerencias.svg',
      tooltip: 'Suplementos de hotel'
    }
  };
  // Usar un Set para evitar duplicados por tipo
  const seenTypes = new Set<string>();
  const result: any[] = [];

  for (const extra of extras) {
    const type = extra?.type || extra?.name; // Ajusta según la estructura de tu objeto

    if (type && typeConfig[type] && !seenTypes.has(type)) {
      seenTypes.add(type);
      result.push({
        type: type,
        image: typeConfig[type].image,
        tooltip: typeConfig[type].tooltip,
        // originalData: extra // Opcional: si necesitas los datos originales
      });
    }
  }

  return result;
}
